 <template>
  <v-dialog
    v-model="dialog"
    max-width="550"
    persistent
  >
    <v-card class="pt-2 pl-0 pr-0">

      <v-card-title
        class="headline-6"
        :class="{'subtitle-2':$vuetify.breakpoint.xs}"
        style="word-break: normal; !important"
      >
        {{(transportadora && !transportadora.id)?$vuetify.lang.t('$vuetify.NOVA_TRANSPORTADORA'):
        $vuetify.lang.t('$vuetify.ATUALIZANDO_TRANSPORTADORA')}}
      </v-card-title>

      <v-form
        ref="form"
        lazy-validation
      >

        <v-row class="ma-0 d-flex justify-center mb-n3">

          <v-col
            cols="6"
            class="ml-n2 mr-6"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                {{$vuetify.lang.t('$vuetify.RAZAO_SOCIAL')}}:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="transportadora.nome"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col
            cols="4"
            class="mr-n2"
          >
            <v-row>
              <span class=" text-right subtitle-2 font-weight-bold grey--text text--lighten-1">
                CNPJ:</span>
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="transportadora.cnpj"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
                 v-mask="'##.###.###/####-##'"
              ></v-text-field>
            </v-row>
          </v-col>

        </v-row>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-lazy
          :options="{threshold: .6}"
          transition="slide-x-transition"
        >
          <span
            class="ml-4 caption red--text"
            v-show="showTransportadoraAlreadyExists"
          >{{$vuetify.lang.t('$vuetify.JA_EXISTE_TRANSPORTADORA')}}</span>
        </v-lazy>

        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="$refs.form.resetValidation(); $refs.form.reset(); close()"
        >
          {{$vuetify.lang.t('$vuetify.CANCELAR')}}
        </v-btn>
        <v-btn
          color="blue darken-2"
          text
          @click="$refs.form.validate(); send(transportadora)"
          :loading="isLoading"
        >
          {{$vuetify.lang.t('$vuetify.ENVIAR')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {

  components: {

  },
  props: {
    close: Function,
    dialog: Boolean,
    send: Function,
    transportadora: Object,
    isLoading: Boolean,
    showTransportadoraAlreadyExists: Boolean,
  },
  methods: {

  },
  data () {
    return {
      rules: [v => v && v.trim().length >= 1 || this.$vuetify.lang.t('$vuetify.CAMPO_OBRIGATORIO'),],
    }
  },
  created: function () {

    this.$root.$on('invalidateFields', () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    })
  }
};
</script>